export enum EBIOMETRICS_STEPS {
  CAMERA = 1,
  WIDGET = 2,
  RESULT = 3,
}

export enum EBIOMETRICS_STATUS {
  FINISHED = 'finished',
  PENDING = 'pending',
  RETRY = 'retry',
}
